module.exports = __webpack_public_path__ + "img/202311_07.b1dc0a81.jpg";